import * as angular from 'angular';
import LibraryProceduresGridBridge from './LibraryProceduresGridBridge';

angular
  .module('flowingly.runner.library')
  .component('libraryProceduresGrid', LibraryProceduresGridBridge);
